module.exports = __webpack_public_path__ + "static/media/server_down.e310b86c.svg";